import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';

@Injectable()
export class SupplierManagementService {
  readonly rootUrl = AppSettings.webApiURL; 

  constructor(public httpClient: HttpClient) { }


  public getSuppliers() {
    return this.httpClient.get(`${this.rootUrl}/api/SupplierManagementApi/GetSuppliers`);
  }

  public getSupplier(id) {
    return this.httpClient.get(`${this.rootUrl}/api/SupplierManagementApi/getSupplier?id=${id}`);
  }

  public SaveSupplier(supplier) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/SupplierManagementApi/SaveSupplier`, supplier, { headers });
  }

  

}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/service/supplier-management.service.ts